import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import * as R from 'ramda';
import { clsx as cx } from 'clsx';
import { Forward } from '../../../internal/components/Forward';
import { useSliderController } from './useSliderController';
import * as styles from './styles.module.css';
import { SliderValueLabelPopover } from './SliderValueLabelPopover';
import { SliderMarks } from './SliderMarks';
import { formatNumber } from '../../../internal/utils/formatNumber';

/**
 * Слайдер с ползунками
 *
 * Поддерживает как одиночные, так и множественные значения
 *
 * На сервере, в целях оптимизации, не рендерятся разделители (marks)
 *
 * @export
 * @template T extends `number | [number, number, ...number[]]`
 * @param {ISliderProps<T>} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Slider(props) {
  var valueLabelDisplay = props.valueLabelDisplay,
    disabled = props.disabled,
    name = props.name;
  var _useSliderController = useSliderController(props),
    sliderRef = _useSliderController.sliderRef,
    valueState = _useSliderController.valueState,
    trackOffset = _useSliderController.trackOffset,
    trackLeap = _useSliderController.trackLeap,
    onMouseDown = _useSliderController.onMouseDown,
    thumbs = _useSliderController.thumbs,
    marks = _useSliderController.marks;
  var values = valueState.values,
    valueDerived = valueState.valueDerived;
  var marked = marks.some(function (_ref) {
    var label = _ref.label;
    return !!label;
  });
  var SliderValueLabelComponent = valueLabelDisplay === 'off' ? Forward : SliderValueLabelPopover;
  return /*#__PURE__*/_jsxs("span", {
    ref: sliderRef,
    className: cx(styles['slider'], marked && styles['marked'], disabled && styles['disabled'], props.__theme === 'input' && styles['internal-theme-input']),
    style: {
      width: props.width
    },
    onMouseDown: onMouseDown,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['rail']
    }), /*#__PURE__*/_jsx("span", {
      className: styles['track'],
      style: {
        left: "".concat(trackOffset, "%"),
        width: "".concat(trackLeap, "%")
      }
    }), name && /*#__PURE__*/_jsx("input", {
      type: "hidden",
      name: name,
      value: valueDerived,
      disabled: disabled
    }), /*#__PURE__*/_jsx(SliderMarks, _objectSpread(_objectSpread({}, props), {}, {
      values: values,
      marks: marks
    })), thumbs.map(function (thumb, index) {
      return /*#__PURE__*/_jsx(SliderValueLabelComponent, {
        open: thumb.open || valueLabelDisplay === 'on',
        label: formatNumber(thumb.value),
        children: /*#__PURE__*/_jsx("span", {
          role: "slider",
          "aria-orientation": "horizontal",
          "data-index": index,
          style: {
            left: "".concat(thumb.percent, "%")
          },
          className: cx(styles['thumb'], thumb.focusVisible && styles['focus-visible'], thumb.active && styles['active']),
          onFocus: thumb.onFocus,
          onBlur: thumb.onBlur,
          onMouseOver: thumb.onMouseOver,
          onMouseLeave: thumb.onMouseLeave,
          onKeyDown: thumb.onKeyDown,
          tabIndex: props.disabled ? undefined : props.tabIndex || 0
        })
      }, index);
    })]
  });
}
Slider.defaultProps = {
  step: 1,
  scale: R.identity,
  valueLabelDisplay: 'auto',
  valueLabelFormat: R.identity
};